import * as types from '../../actions/ActionTypes';

export const initialState = {
  startPage: {
    template_type: 'default',
    template_theme: 'no_type',
    fgosTitle: '',
    fgosText: '',
    mdkTitle: '',
    mdkText: '',
    mainImg: '',
    background: '',
    theme: '',
    info: '',
    tags: '',
    modules: [
      {
        mainTitle: '',
        text: '',
        title: '',
        description: '',
        url: ''
      }
    ] 
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FILL_START_PAGE:
      return {
        ...state,
        startPage: action.startPage,
      };
    default:
      return state;
  }
}
